import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=733184ac&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"
import style0 from "./Awards.vue?vue&type=style&index=0&id=733184ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733184ac",
  null
  
)

export default component.exports